export enum EnumChecklistState {
    DRAFT = 'DRAFT',
    APPROVED = 'APPROVED',
}

export type TChecklistItemValueType = 'SHORT' | 'STRING';

export interface IChecklistManagementItemResource {
    readonly itemUuid: string;
    readonly questionType: string;
    readonly questionBlock: string;
    readonly question: string;
    readonly example: string;
    readonly answer: string;
    readonly valueType: TChecklistItemValueType;
    readonly weight: number;
}

export interface IChecklistManagementResource {
    readonly id: number;
    readonly checklistUuid: string;
    readonly name: string;
    readonly description: string | null;
    readonly state: EnumChecklistState;
    readonly items: IChecklistManagementItemResource[];
}

export interface IChecklistManagementListResource {
    readonly pageToken: string;
    readonly checklists: IChecklistManagementResource[];
    readonly total: number;
}

export interface IChecklistManagementItemEditBody {
    readonly questionType: string;
    readonly question: string;
    readonly example: string;
    readonly answer: string;
    readonly valueType: TChecklistItemValueType;
    readonly weight: number;
}

export interface IChecklistManagementEditBody {
    readonly name: string;
    readonly description: string | null;
}
